import axios from "axios";

class Api {
	constructor() {
		this.base_url = process.env.VUE_APP_API_BASE_URL
	}

	fetchOrderDetail(orderId) {
		return axios.get(`${this.base_url}/userportal/order/${orderId}/payments`)
	}

	fetchOrderInstallments(userId) {
		return axios.get(`${this.base_url}/userportal/order/${userId}/userPayments`)
	}
	
	getSettings() {
		return axios.get(`${this.base_url}/userportal/settings/user_portal`)
			.then(r => Promise.resolve(r.data.data));
	}
}

export default new Api();